import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import DocumentsSection from '../../DocumentsSection'

import useDataProcess from 'hooks/useDataProcess'
import useDocuments from 'hooks/useDocuments'

import { Box, Typography } from '@material-ui/core'

const Documents = ({ description }) => {
  const { data, toNextStep, setToNextStep, nextStep } = useDataProcess()
  const { dataProcess } = data
  const { loading } = useDocuments()

  useEffect(() => {
    if (toNextStep) {
      if (!loading) {
        nextStep()
        setToNextStep(false)
      }
    }
    // eslint-disable-next-line
  }, [nextStep])

  return (
    <Box display="flex" flexDirection="column" gridGap={2} py={1} px={2}>
      <Typography>{description}</Typography>
      <DocumentsSection dataProcessId={dataProcess?.id} />
    </Box>
  )
}

Documents.propTypes = {
  description: PropTypes.string,
}

export default Documents
